import { useSelector, useDispatch } from "react-redux";
import { filterByBrand, filterByCategory } from "../../../../redux/newProductActions";
import style from './Filters.module.css';

const Filters = () => {

    const dispatch = useDispatch();
    const { newProducts } = useSelector((state) => state.newProducts);

    const uniqueBrands = [...new Set(newProducts.map((newProduct) => newProduct.brand))].sort((a, b) => a.localeCompare(b));
    const uniqueCategories = [...new Set(newProducts.map((newProduct) => newProduct.category).filter(category => category !== undefined))].sort((a, b) => a.localeCompare(b));

    
    const handleFilterBrand = (event) => {
        dispatch(filterByBrand(event.target.value));
    };

    const handleFilterCategory = (event) => {
        dispatch(filterByCategory(event.target.value));
    };

    return(
        <div className={style.div}>
            <div className={style.filter}>
                <p>Filtrar por marca:</p>
                <select onChange={handleFilterBrand}>
                    <option value="allBrands">Todas las marcas</option>
                    {uniqueBrands.map((brand) => (
                        <option value={brand} key={brand}>
                            {brand}
                        </option>
                    ))}
                </select>
            </div>

            <div className={style.filter}>
                <p>Filtrar por categorías:</p>
                <select onChange={handleFilterCategory}>
                    <option value="allCategories">Todos las categorías</option>
                    {uniqueCategories.map((category) => (
                        <option value={category} key={category}>
                            {category}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
}

export default Filters;